import { AutogenLayoutMasterCodeControl } from "./autogen/AutogenLayoutMasterCodeControl";
import { DataSourceAction, DataSourceExecutionEvent, DropdownSelectionEvent } from "@mcleod/components";
import { MaskTooltipHelper } from "./MaskTooltipHelper";
import { StringUtil } from "@mcleod/core";

export class MasterCodeControl extends AutogenLayoutMasterCodeControl {
    sourceAutogenAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            MaskTooltipHelper.setTooltipData(event.dataSource.summaryData.get("mask_legend", []));
            MaskTooltipHelper.setTooltipContent(this.textboxMask);
            this.textboxMask.items = event.dataSource.activeRow?.get("mask_valid_values", []);
            this.configureForMaskSelection();
        }
    }

    textboxMaskAfterDropdownSelection(event: DropdownSelectionEvent) {
        if (event.selection.value !== event.deselection.value)
            this.configureForMaskSelection();
    }

    private configureForMaskSelection() {
        const mask = this.textboxMask.selectedItem?.value;
        if (StringUtil.isEmptyString(mask))
            return;
        "999999" === mask ? this.configureForNumericMask() : this.configureForAlphaMask();

    }

    private configureForNumericMask() {
        this.textboxStartAt.text = "1";
        this.textboxStartAt.required = true;
        this.textboxStartAt.enabled = true;

        this.textboxMinChars.text = "6";
        this.textboxMinChars.required = true;
        this.textboxMinChars.enabled = true;

        this.textboxDupHandling.setSelectedItemFromValue("S");
        this.textboxDupHandling.enabled = false;
    }

    private configureForAlphaMask() {
        this.textboxStartAt.text = "";
        this.textboxStartAt.required = false;
        this.textboxStartAt.enabled = false;

        this.textboxMinChars.text = "";
        this.textboxMinChars.required = false;
        this.textboxMinChars.enabled = false;

        this.textboxDupHandling.enabled = true;
    }
}
